const FLOW_ORIGIN = "https://www.peoplesmart.com";

const FLOW_PATHS = {
  people: "/lp/70c1c4/2/building-report",
  company: "/lp/88dce3/3/building-report",
  subscribe: "/lp/70c1c4/3/subscribe",
};

export function goToFlow(key, params) {
  const path = FLOW_PATHS[key];
  if (!path) {
    return;
  }

  const query = Object.keys(params || {})
    .filter((name) => params[name])
    .map((name) => name + "=" + encodeURIComponent(params[name]))
    .join("&");

  window.location.href = FLOW_ORIGIN + path + (query ? "?" + query : "");
}
